import useDetectCountry from '@hooks/useDetectCountry'

const useIsIndia = () => {
  const { countryCode } = useDetectCountry()

  return { isIndia: countryCode === 'IN' }
}

export default useIsIndia
